export enum DealsPermissions {
  DEALS_ALL = "Travel:Deals:*",
  DEALS_READ = "Travel:Deals:Read",
  DEALS_WRITE = "Travel:Deals:Write",
}

export function hasAccessToDeals(userPermissions: string[]): boolean {
  const permissions = [
    DealsPermissions.DEALS_READ.toString(),
    DealsPermissions.DEALS_WRITE.toString(),
    DealsPermissions.DEALS_ALL.toString(),
  ];
  return userPermissions.some((permission) => permissions.includes(permission));
}
